import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class UpdateGroupErrorAction implements Action {
  public static readonly type = 'UpdateGroupErrorAction';

  constructor(public error: BijbError) {
  }

  public type = UpdateGroupErrorAction.type;
}
